import React, {Component} from 'react';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';
import {Button, Row, Input, Label, Col, ListGroup} from 'reactstrap'
import Select from 'react-select';
import TextArea from 'apa/components/TextArea';
import { BaseUrl } from '../BaseUrl/BaseUrl';

function getOptions(trainingTemplateList) {
  const options = []
  for(let template of trainingTemplateList) {
    options.push({
      label: template.name,
      value: template.id,
      questionList: template.data
    })
  }
  return options
}

@connect(
    state => {
      return {
        customers: state.customers,
        auth: state.apa
      }
    },
    dispatch => {
      return {
        fetchCustomer: (customer_id, callback) => {
          dispatch(customers.fetchCustomer(customer_id, callback))
        }
      }
    }
)
export default class NewTraining extends Component {

  state = {
    isSubmitting: false,
    isLoading: true,
    customer: null,
    questionList: [],
    options: [],
    description: '',
    name: '',
    start_at: '',
    end_at: '',
    codes: 0,
    file: '',
    mail: '',
    data: []
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    this.props.fetchCustomer(id, customer => {
      this.setState({customer: customer})
      this.getTrainingTemplateList()
    })
  }

  @autobind
  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    if(name === 'file') {
      this.setState({
        [name]: target.files[0]
      })
      return;
    }
    this.setState({
      [name]: value
    })
  }

  @autobind
  getTrainingTemplateList() {
    const headers = {
      'Authorization': `Token ${this.props.auth.token}`
    };
    fetch(
        `${BaseUrl}/api/trainings/`,
        {headers, method: 'GET'}
    ).then(res => res.json())
        .then(
            (res) => {
              this.setState({isLoading: false,
                options: getOptions(res)
              })
            }
        )
  }

  @autobind
  onSubmit(event) {
    event.preventDefault();
    const {
      name,
      customer,
      start_at,
      end_at,
      codes,
      file,
      mail,
      description,
      data
    } = this.state
    if(data.length === 0) {
      return;
    }
    this.setState({
      isLoading: true
    });
    const headers = {
      'Authorization': `Token ${this.props.auth.token}`
    };
    const body = new FormData();
    body.append('customer', customer.id);
    body.append('name', name);
    body.append('start_at', start_at);
    body.append('end_at', end_at);
    body.append('presentation', file);
    body.append('codes', codes);
    body.append('contact', mail);
    body.append('description', description);
    body.append('data', JSON.stringify(data));
    console.log("Body", body)
    fetch(
        `${BaseUrl}/api/customers/training/`,
        {headers, method: 'POST', body}
    ).then(res => res.json())
    .then(() => this.props.history.push(
            `/customer/${customer.id}/training`))
  }

  @autobind
  setQuestion(number, question) {
    let data = this.state.data;
    const index = data.findIndex(
        n => n.id === question.value || question.id
    )
    const obj = {id: question.value || question.id, number: number, label: question.label, questionList: question.questionList}
    if(index < 0) {
      data.push(
          obj
      )
    } else {
      data = data.map(
          i => i.id === obj.id ? obj : i
      );
    }
    this.setState({data: data});
  }

  render() {
    const id = this.props.match.params.id;
    const customer = this.state.customer;
    const options = this.state.options;
    const {
      handleChange,
      onSubmit
    } = this;
    if (this.state.isLoading)
      return <Loading/>
    const {
      questionList,
      start_at,
      end_at,
      codes,
      name,
    } = this.state;
    const contactList = customer.contacts.map(
        contact => ({
          label: `${contact.name} - ${contact.email}`,
          value: contact.email
        })
    )
    return (
        <DetailContainer id={id}>
          <h1>{customer.name}</h1>
          <h2>Neue Schulung anlegen</h2>
          <Row>
            <Col>
              <Label>Name</Label>
              <Input name='name' onChange={handleChange} value={name}/>
            </Col>
            <Col>
              <Label>Start</Label>
              <Input name='start_at' onChange={handleChange} value={start_at} type="date"/>
            </Col>
            <Col>
              <Label>Ende</Label>
              <Input name='end_at' onChange={handleChange} value={end_at} type="date"/>
            </Col>
            <Col>
              <Label>Teilnehmer</Label>
              <Input name='codes' onChange={handleChange} value={codes} type="number" min={0}/>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label>Beschreibung</Label>
              <TextArea name='description' value={this.state.description} onChange={handleChange} />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label>Präsentation</Label>
              <Input name='file' onChange={handleChange} type="file"/>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label>E-Mail des Verantwortlichen</Label>
              <Select options={contactList} onChange={
                option => {
                  this.setState({
                    mail: option.value
                  })
                }
              } />
            </Col>
          </Row>
          <br/>
          <Row>
            <Label>Fragen</Label>
          </Row>
          <br/>
          <Select isMulti options={options} onChange={
            (e, change) => {
              const {
                action,
                option,
                removedValue
              } = change;
              let _data = this.state.data
              let _questionList = this.state.questionList
              if(action === 'select-option') {
                console.log('select', option)
                _questionList.push(option)
              }
              if(action === 'remove-value') {
                _questionList = _questionList.filter(
                    q => q.value !== removedValue.value
                )
                _data = _data.filter(
                    q => q.id !== removedValue.value
                )
              }
              if(action === 'clear') {
                _data = []
                _questionList = []
              }
              this.setState({
                data: _data,
                questionList: _questionList
              })
            }
          }/>
          <br/>
          <ListGroup>
            {
              questionList.map(
                  question => <Row className="mt-1" key={`question_selection_${question.label}`}>
                    <Col>
                      <strong>{question.label}</strong>
                    </Col>
                    <Col>
                      <Input placeholder="Fragen" type="number" min={1} max={question.questionList.length} onChange={e => this.setQuestion(e.target.value, question)}/>
                    </Col>
                  </Row>
              )
            }
          </ListGroup>
          <br/>
          <Button onClick={onSubmit} color='primary'>Speichern</Button>
        </DetailContainer>
    )
  }
}

